// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3V1oj","header":"Messages_header__2ktAa"};